import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../sabith logo.png';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/wedding', label: 'Wedding' },
  { to: '/baby-shoot', label: 'Baby Shoot' },
  { to: '/stills', label: 'Stills' },
  { to: '/anniversary', label: '25th Anniversary' },
];

function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(() => window.innerWidth >= 1024);
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 1024px)');
    const handler = (e) => setIsDesktop(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return isDesktop;
}

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isDesktop = useIsDesktop();

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header
      style={{
        backgroundColor: '#1a1a1a',
        padding: '14px 0',
        borderBottom: '1px solid rgba(201,169,110,0.08)',
      }}
    >
      <div
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '0 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img
            src={logo}
            alt="Sabitha Studio"
            style={{ height: '48px', width: 'auto', maxWidth: '170px', objectFit: 'contain' }}
          />
        </Link>

        {/* Desktop Nav */}
        {isDesktop && (
          <nav style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`cat-pill ${location.pathname === link.to ? 'active' : ''}`}
                style={{ fontSize: '11px' }}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+919703377033"
              className="btn-outline"
              style={{ padding: '10px 24px', fontSize: '10px' }}
            >
              Book Now
            </a>
          </nav>
        )}

        {/* Hamburger button — mobile only */}
        {!isDesktop && (
          <button
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '44px',
              height: '44px',
              background: 'none',
              border: '1px solid rgba(201,169,110,0.3)',
              borderRadius: '6px',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            {menuOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 6L18 18" stroke="#c9a96e" strokeWidth="2.5" strokeLinecap="round" />
                <path d="M18 6L6 18" stroke="#c9a96e" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 7H21" stroke="#c9a96e" strokeWidth="2.5" strokeLinecap="round" />
                <path d="M3 12H21" stroke="#c9a96e" strokeWidth="2.5" strokeLinecap="round" />
                <path d="M3 17H21" stroke="#c9a96e" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
            )}
          </button>
        )}
      </div>

      {/* Mobile dropdown menu */}
      {!isDesktop && menuOpen && (
        <div
          style={{
            padding: '20px 24px',
            borderTop: '1px solid rgba(201,169,110,0.1)',
            backgroundColor: 'rgba(26,26,26,0.98)',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              style={{
                display: 'block',
                padding: '12px 0',
                fontSize: '13px',
                fontFamily: "'Montserrat', sans-serif",
                letterSpacing: '0.15em',
                textTransform: 'uppercase',
                textDecoration: 'none',
                color: location.pathname === link.to ? '#c9a96e' : 'rgba(250,246,240,0.6)',
                borderBottom: '1px solid rgba(201,169,110,0.06)',
              }}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="tel:+919703377033"
            className="btn-outline"
            style={{
              display: 'block',
              textAlign: 'center',
              marginTop: '12px',
              padding: '14px 0',
              fontSize: '11px',
            }}
          >
            Book Now
          </a>
        </div>
      )}
    </header>
  );
}
